import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBlueEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#03A9F4",
		fillRule: "nonzero",
		d: "M15.762 3.98l-1.58 1.579-3.741-3.741 1.578-1.58c.536-.536 1.072 0 1.072 0l2.67 2.67s.537.536 0 1.072zM0 16l4.536-.796-3.75-3.75L0 16zm1.312-5.055l3.742 3.742 8.554-8.553-3.742-3.742-8.554 8.553z"
	})
});
export default SvgBlueEdit;
